import React, { useEffect, useState } from "react";
import Chatheader from "../patientChat/chatheader/chatheader"
import { useStateValue } from '../../../stateprovider';
import "./signout.css";
import { useNavigate } from "react-router-dom";
import ready from "../../../assets/Animal.png";

const SignoutComp = () => {
    const [{ }, dispatch] = useStateValue();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: false
        });

    }, []);


    return <div className="app_complaint app_extend">
        <div className="app_summaryready_container" style={{ height: "fit-content" }}>
            <img src={ready} alt="pic" className="app_summaryImage" />

            <h6>You have successfully
                signed Out from your account</h6>
            <button onClick={()=> navigate("/login")}>Continue to login</button>


        </div>

    </div>
}
export default SignoutComp;